import * as React from "react";
import {
  ContractDebitType,
  Elavtal,
  Elavtalsstatus,
  PropertyType,
  SelfServiceClient, Channel
} from "../api/ApiClient";
import { UserContext } from "../context/UserContext";
import PriceDetails from "./PriceDetails";

interface Props {}
interface State {
  fixedPrice: number;
  elavtalId?: string;
}

export class ElavtalContainer extends React.Component<Props, State> {
  static contextType = UserContext;
  context!: React.ContextType<typeof UserContext>;

  private readonly selfServiceClient: SelfServiceClient =
    new SelfServiceClient();
  readonly state: State = {
    fixedPrice: 0,
    elavtalId: null,
  };
  async componentDidMount() {
    this.selfServiceClient.setToken(this.context.token);
    if (this.context.currentElavtal != null) {
      let Fp = await this.selfServiceClient.fixedPrice(
        this.context.currentElavtal.id,
        this.context.currentElavtal.property.consumption
      );

      this.setState({
        fixedPrice: Fp.price,
        elavtalId: this.context.currentElavtal.id,
      });
    }
  }
  async componentDidUpdate(prevProps: Props, prevState: State) {
    if (
      this.context.currentElavtal != null &&
      (prevState?.elavtalId != this.state.elavtalId ||
        prevState?.elavtalId == null)
    ) {
      let Fp = await this.selfServiceClient.fixedPrice(
        this.context.currentElavtal.id,
        this.context.currentElavtal.property.consumption
      );

      this.setState({
        fixedPrice: Fp.price,
        elavtalId: this.context.currentElavtal.id,
      });
    }
  }

  render() {
    return (
      <div>
        {this.context.currentElavtal && (
          <React.Fragment>
            <h2>Min bostad</h2>
            {this.context.elavtal && this.context.elavtal.length > 1 ? (
              <div className="form-group">
                <select
                  className="form-control mt-3"
                  value={this.context.currentElavtal.id}
                  onChange={this.changeElavtal}>
                  {this.context.elavtal.map((elavtal: Elavtal) => {
                    return (
                      <option value={elavtal.id} key={elavtal.id}>
                        {elavtal.property.street +
                          ", " +
                          elavtal.property.city +
                          (elavtal.property.type == PropertyType.PRODUCING
                            ? " (Produktion)"
                            : "") +
                          (elavtal.elavtalsstatus ==
                          Elavtalsstatus.LeveransAvslutad
                            ? " - Avslutad"
                            : "") +
                          (elavtal.elavtalsstatus == Elavtalsstatus.Avbruten
                            ? " - Avbruten"
                            : "")}
                      </option>
                    );
                  })}
                </select>
              </div>
            ) : (
              <p>
                {this.context.currentElavtal.property.street}
                <br />
                {this.context.currentElavtal.property.zipCode}{" "}
                {this.context.currentElavtal.property.city}
              </p>
            )}

            {this.context.currentElavtal &&
            this.context.currentElavtal?.elavtalsstatus !=
              Elavtalsstatus.Avbruten ? (
              <>
                <h2>
                  {this.deliveryContractToString(this.context.currentElavtal)}
                </h2>
                <p className="copy">
                  <>
                    {this.context.currentElavtal.elavtalsstatus ==
                    Elavtalsstatus.LeveransAvslutad ? (
                      <>
                        Ditt avtal avslutades{" "}
                        {this.context.currentElavtal.endDate?.format(
                          "YYYY-MM-DD"
                        )}
                        .
                      </>
                    ) : (
                      <>
                        {this.context.currentElavtal.property.type ==
                        PropertyType.CONSUMING
                          ? "Du har ett avtal utan bindningstid och uppsägningstid med 100% fossilfri el. Din månadsavgift är " +
                            Math.round(this.state.fixedPrice) +
                            " kr per månad. "
                          : "Du har ett rörligt timprisavtal avtal utan bindningstid och uppsägningstid. "}
                      </>
                    )}Se dina prisdetaljer{" "}
                    <a href="#priceDetailsModal" data-toggle="modal">
                     här
                    </a>
                    {" "} och du hittar dina avtalsvillkor {" "}
                    <a href="/villkor">
                     här.
                    </a>
                  </>
                </p>
                <h2>100% FOSSILFRITT</h2>
                <p className="copy">
                  Du har idag el till 100% från sol, vind, kärnkraft och vatten. Vill du ha 100% förnybar el istället så kan du maila oss på{" "}
                  <a href="mailto:info@renenkelbilligel.se?subject=Till%C3%A4gg%20sol,%20vind%20och%20vatten">
                    info@renenkelbilligel.se
                  </a>{" "}
                  för att beställa tillägget eller om du har några frågor.
                </p>
              </>
            ) : null}
            <h2>
              {this.context.currentElavtal?.elavtalsstatus ==
              Elavtalsstatus.LeveransAvslutad
                ? "Har du flyttat?"
                : this.context.currentElavtal?.reasonForTerminationTag
                    ?.externalId ==
                  "internal.reasonForTermination.partOfRentCollectiveMeasurement"
                ? "Lycka till med flytten"
                : "Ska du flytta?"}
            </h2>
            <p className="copy">
              Glöm inte att teckna avtal på din nya adress. Det är snabbt löst,
              klicka på knappen nedan, det tar knappt en minut.
            </p>
            <p className="text-center">
              <a
                className="btn btn-primary btn-lg mt-3 mb-2"
                href={`/bli-kund?pid=${this.context.customer.pid}&firstName=${this.context.customer.firstName}&lastName=${this.context.customer.lastName}&phone=${this.context.customer.mobile}&email=${this.context.customer.email}&isCurrent=0`}
                role="button">
                Teckna avtal
              </a>
            </p>
          </React.Fragment>
        )}
        <PriceDetails
          elomrade={this.context.currentElavtal?.property.netArea.electricityArea}
          channel={Channel[this.context.currentElavtal?.salesChannel.channelIndex]}/>
      </div>
    );
  }

  deliveryContractToString = (delivery?: Elavtal) => {
    console.debug("deliveryContractToString", delivery);
    if (delivery?.contracts?.length == 1) {
      console.debug(
        "deliveryContractToString public name",
        delivery?.contracts[0].contractType?.publicName
      );
      if (delivery?.contracts[0].contractType?.publicName) {
        return delivery?.contracts[0].contractType?.publicName;
      }
      if (delivery?.property?.type == PropertyType.PRODUCING) {
        return "Produktionsavtal";
      }
      if (
        delivery?.contracts[0].contractType?.contractDebitType ==
        ContractDebitType.HOURLY
      ) {
        return "Timprisavtal";
      }
    }
    return "Rörligt avtal";
  };

  changeElavtal = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    let elavtal = this.context.elavtal.find(
      (elavtal: Elavtal) => elavtal.id == event.target.value
    );
    if (elavtal) {
      this.context.setCurrentElavtal(elavtal);
      let Fp = await this.selfServiceClient.fixedPrice(
        this.context.currentElavtal.id,
        this.context.currentElavtal.property.consumption
      );

      this.setState({ fixedPrice: Fp.price });
    }
    console.debug("Change elavtal", elavtal);
  };
}
